import { render, staticRenderFns } from "./SystemJobsTable.vue?vue&type=template&id=6a4f3bf6&scoped=true&"
import script from "./SystemJobsTable.vue?vue&type=script&lang=js&"
export * from "./SystemJobsTable.vue?vue&type=script&lang=js&"
import style0 from "./SystemJobsTable.vue?vue&type=style&index=0&id=6a4f3bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f3bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
